import "regenerator-runtime/runtime";
import { compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";

import reducers from "../reducers";
import rootSaga from "../sagas";

export default function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware();
  let middleware = [sagaMiddleware];
  let enhancers = [];

  const composeEnhancers = (window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  const enhancer = composeEnhancers(...[applyMiddleware(...middleware), ...enhancers]);

  const store = createStore(reducers, initialState, enhancer);
  let sagaTask = sagaMiddleware.run(rootSaga);

  if (import.meta.hot) {
    import.meta.hot.accept("../reducers", (newModule) => {
      const nextReducer = newModule.default;
      store.replaceReducer(nextReducer);
    });

    import.meta.hot.accept("../sagas", (newModule) => {
      const getNewSagas = newModule.default;
      sagaTask.cancel();
      sagaTask.done.then(() => {
        sagaTask = sagaMiddleware.run(function* replacedSaga(action) {
          yield getNewSagas();
        });
      });
    });
  }

  return store;
}
